import{jsx as e}from"react/jsx-runtime";import{useNavigate as r}from"react-router-dom";import{styled as t}from"styled-components";import{restClient as o}from"../../../lib/index.mjs";const a=t.div`
  position: absolute;
  left: 570px;
`,n=t.button`
  float: left;
  width: 36px;
  height: 36px;
  margin: 1px 10px auto 10px;
  border: 2px solid #708090;
  border-radius: 6px 6px 6px 6px;
  overflow: hidden;
  cursor: pointer;

  &.fa {
    background: url('images/fa.png') no-repeat center;
  }
  &.la {
    background: url('images/la.png') no-repeat center;
  }
  &.ra {
    background: url('images/ra.png') no-repeat center;
  }
  &.iv {
    background: url('images/iv.png') no-repeat center;
  }
  &.lm {
    background: url('images/lm.png') no-repeat center;
  }
`;function i(){const t=r();return e(a,{className:"subsystem-group",children:e(n,{id:"fa",className:"fa",onClick:async()=>{await o.auth.post("/switch-subsystem",{subSystem:"fa"}),t("/fa/main-menu")}})})}export{i as SubSystemGroup};
